// Moved to @livingsyncs/ui (frontend split epic, Phase 2 Task 2.4). Shim kept
// so nothing importing the old path breaks during the transition.
// Real function declaration, not a reference copy — see hooks/useAuth.ts.
import * as _module from "@livingsyncs/ui";

export function lazyNamed<M, K extends keyof M>(
  loader: () => Promise<M>,
  name: K,
) {
  return _module.lazyNamed(loader, name);
}
